import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SiteMap from "../components/SiteMap";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import MaterialFullPage from "../components/commons/MaterialFullPage";

const MaterialItemId = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [material, setMaterial] = useState(null);
    const [searchParams] = useSearchParams();

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        const loadMaterial = async () => {
            const materialsData = await axios.get(
                `https://mw2c0cho61.execute-api.sa-east-1.amazonaws.com/production/materials/links/find?link=${searchParams.get("link")}`,
                {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    crossDomain: true,
                }
            );
            
            setMaterial(materialsData.data[0]);
        };

        loadMaterial();

        window.scrollTo({
            top: 0,
            behavior: "smooth", // for smoothly scrolling
        });

        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMobile = width <= 768;

    return (
        <>
            <header>
                <Header isMobile={isMobile} />
            </header>
            <main id="conteudo-principal">
                <h1 className="sr-only">Material</h1>
                {material && <MaterialFullPage material={material} />}
            </main>
            <footer>
                <Footer />
                <SiteMap />
            </footer>
        </>
    );
};

export default MaterialItemId;
